// @ts-check
import Swal from 'sweetalert2'

export async function askingAlert ({ html, cancelText, confirmText }) {
  const response = await Swal.fire({
    icon: 'question',
    html,
    showCancelButton: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    cancelButtonText: cancelText,
    confirmButtonText: confirmText
  })

  return response
}

export function alertWithRedirection ({ html, icon, redirect }) {
  Swal.fire({
    icon,
    html,
    showCancelButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCloseButton: true
  })
    .then(() => {
      window.location.href = redirect
    })
}

export function waitingAlert (html) {
  Swal.fire({
    icon: 'warning',
    html,
    showCancelButton: false,
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCloseButton: true
  })
}



// WEBPACK FOOTER //
// ./resources/js/utils/alerts.js